module.exports = __webpack_public_path__ + "static/media/spinner.1dee295e.gif";